import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


@Component({
  selector: 'app-refund-modal',
  templateUrl: './refund-modal.component.html',
  styleUrls: ['./refund-modal.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
]
})
export class RefundModalComponent {
  selectedOption: 'full' | 'partial' | null = null;
  partialAmountControl = new FormControl('', [
    Validators.required,
    Validators.min(0.01),
    Validators.max(this.data.maxAmount)
  ]);

  constructor(
    public dialogRef: MatDialogRef<RefundModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { maxAmount: number }
  ) {}

  selectOption(option: 'full' | 'partial') {
    this.selectedOption = option;
    if (option === 'full') {
      this.partialAmountControl.reset();
    }
  }

  onConfirm() {
    if (this.selectedOption === 'full') {
      this.dialogRef.close({ type: 'full', amount: this.data.maxAmount });
    } else if (this.selectedOption === 'partial' && this.partialAmountControl.valid) {
      this.dialogRef.close({ type: 'partial', amount: parseFloat(this.partialAmountControl.value) });
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  get isValid(): boolean {
    if (this.selectedOption === 'full') return true;
    if (this.selectedOption === 'partial') return this.partialAmountControl.valid;
    return false;
  }
}
